// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryColumn.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Category Column component
 */

!(function () {
  var React = require('react');
  var Select = require('share/components/controls/multiSelectBox/Izenda.Select');
  var localizer = require('share/localization/Izenda.Localizer');
  const { find, trim, template } = require('lodash/fp');

  function preventAddNew() {
    return false;
  }

  function renderCategory(querySourceTypeDetails) {
    var props = this.props;

    var querySourceVM = props.store;
    var inputProps = { maxLength: '50' };
    var onAddNew = addNewCategories;
    var noResultsText = localizer.getText('QUERY_SOURCE_TYPE_CONFIG_LABEL_CATEGORY_COLUMN_ENTER_TO_CREATE_COLUMN');

    // If user does not have DataSetupAdvancedSettingsCategory permission, then he cannot add new category.
    if (!props.authorization.checkPrivileges([props.authorizationConstants.PERMISSION_KEY.DataSetupAdvancedSettingsCategory])) {
      onAddNew = preventAddNew;
      noResultsText = null;
    }

    return (
      <Select simpleValue options={querySourceVM.categoryList.categoryMetadatas}
        labelKey={'name'}
        valueKey={'id'}
        inputProps={inputProps}
        value={querySourceTypeDetails.getCategory()}
        noResultsText={noResultsText}
        onChange={updateValue}
        onAddNew={onAddNew} />
    );

    function updateValue(value, label, isNew) {
      value = null;
      var existedCategory =  find({ 'name':  trim(label) }, querySourceVM.categoryList.categoryMetadatas);
      if (existedCategory) {
        value = existedCategory.isNew ? null : existedCategory.id;
        label = existedCategory.name;
        isNew = existedCategory.isNew;
      }
      return querySourceTypeDetails.setCategory(value, label, isNew);
    }

    function addNewCategories(newObject) {
      var isExist =  find({ 'name':  trim(newObject.name) }, querySourceVM.categoryList.categoryMetadatas);
      !isExist && querySourceVM.categoryList.addCategory( trim(newObject.id),  trim(newObject.name), null);
    }
  }

  module.exports = {
    render: renderCategory
  };

})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/QuerySourceType/Izenda.CategoryColumn.jsx